import { Cog6ToothIcon } from "@heroicons/react/24/outline"
import { useSharedTimeCapsuleBySlug } from "api/ApiHooks"
import { NewTimeCapsuleEntryForm } from "components/NewTimeCapsuleEntryForm"
import { OpenTimeCapsuleTimeline } from "components/OpenTimeCapsuleTimeline"
import dayjs from "dayjs"
import { Link, useParams } from "react-router-dom"
import { formatTimeDiff } from "utils/FormatTimeDiff"

export const MemberTimeCapsulePage: React.FC = () => {
  const { creatorId, slug } = useParams()
  const { data, isLoading } = useSharedTimeCapsuleBySlug(creatorId || "", slug || "")

  const isOpen = data?.opensAt && new Date(data.opensAt) < new Date()

  return (
    <>
      {isLoading && <p>Loading...</p>}
      {data && (
        <div className="flex justify-between mb-6 pb-4 border-b border-gray-200 dark:border-gray-800">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
              {data.name}
            </h1>
            <h2 className="text-lg text-gray-900 dark:text-white">
              by {data.creatorName}
            </h2>
            {data.opensAt && (
              <p className="text-gray-500 dark:text-gray-400 mt-2">
                {isOpen
                  ? `Opened ${formatTimeDiff(data.opensAt)} ago`
                  : `Opens in ${formatTimeDiff(data.opensAt)}`}{" "}
                ({dayjs(data.opensAt).format("MMMM D, YYYY")})
              </p>
            )}
          </div>
          <div>
            <Link to={`/time-capsules/shared/${creatorId}/${slug}/settings`}>
              <span className="sr-only">Settings</span>
              <Cog6ToothIcon className="w-6 h-6 text-gray-500 dark:text-gray-400 cursor-pointer hover:text-primary-600" />
            </Link>
          </div>
        </div>
      )}
      {data && !isOpen && <NewTimeCapsuleEntryForm {...data} />}
      {data && isOpen && <OpenTimeCapsuleTimeline timeCapsuleId={data.id} />}
    </>
  )
}
